import { Box, Inline, Stack } from '@atlaskit/primitives';
import React from 'react';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';

export const ListItemSkeleton = (): React.ReactNode => (
	<Box paddingBlock="space.150" paddingInline="space.200">
		<Inline space="space.150">
			<Box paddingBlock="space.025">
				<LoadingSkeleton width="32px" height="32px" />
			</Box>
			<Stack space="space.050">
				<LoadingSkeleton width="240px" height="20px" />
				<LoadingSkeleton width="112px" height="12px" />
			</Stack>
		</Inline>
	</Box>
);
